import siteSearchGroup from '@/components/search-group.vue'
import { mailLetterFamily, mailEvent } from '@/api/mail'
const columns = [
  // {
  //   title: '',
  //   enTitle: 'radio',
  //   width: 60,
  //   dataIndex: 'selected',
  //   slot: 'omission'
  // },
  {
    title: '',
    enTitle: 'Letter Purpose',
    width: 200,
    dataIndex: 'subject',
    slot: 'omission'
  },
  {
    title: '',
    enTitle: 'Letter Family Group by',
    width: 200,
    dataIndex: 'letterFamily',
    slot: 'letterFamily'
  }
]
export default {
  components: {
    siteSearchGroup
  },
  data() {
    return {
      params: {},
      columns: columns,
      dataSource: [],
      pagination: {
        total: 0,
        size: 10,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        showSizeChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      },
      letterFamilyList: [
        { value: 'aaaa', key: 'ccc' },
        { value: 'fff', key: 'kk' }
      ],
      selectList: []
    }
  },
  async mounted() {
    this.getMailLetter()
    await this.getList()
    // this.editRadio()
  },
  methods: {
    // 获取信件组
    async getMailLetter() {
      this.letterFamilyList = await mailLetterFamily.getAll()
    },
    async getList(page, size) {
      if (!page) {
        page = 1
      }
      if (!size) {
        size = this.pagination.size
      }
      let event = this.$route.query.event
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: size
        // event
      })
      const { list, pageIndex, pageSize, total } = await mailEvent.event(
        event,
        data
      )
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
      this.editRadio()
    },
    editRadio() {
      this.$nextTick(() => {
        let dataSource = this.dataSource
        this.$refs[
          'system-manage-email-actions-table'
        ].$data.selectOptions = dataSource.filter(item => item.selected == true)
        this.selectList = this.$refs[
          'system-manage-email-actions-table'
        ].$data.selectOptions
      })
    },
    handleClear() {
      this.params.keyword = ''
      this.getList()
    },
    async selectData(list, val) {
      let events = this.$route.query.event
      let data = { templateId: val.id }
      const index = this.$refs[
        'system-manage-email-actions-table'
      ].$data.selectOptions.findIndex(item => {
        return item.id === val.id
      })

      if (!val.selected) {
        try {
          await mailEvent.associatedList(events, data)
          val.selected = true
          if (index === -1) {
            this.$refs[
              'system-manage-email-actions-table'
            ].$data.selectOptions.push(val)
          }
          // else {
          //   if (index === -1 && val.selected) {
          //     console.log('aaa')
          //     this.$refs[
          //       'system-manage-email-actions-table'
          //     ].$data.selectOptions.push(val)
          //   }
          // }
        } catch (err) {
          if (index != -1) {
            this.$refs[
              'system-manage-email-actions-table'
            ].$data.selectOptions.splice(index, 1)
          }
        }
      }

      // console.log(
      //   this.$refs['system-manage-email-actions-table'].$data.selectOptions,
      //   'this.$parent.$data.selectOptions终'
      // )
      this.selectList = this.$refs[
        'system-manage-email-actions-table'
      ].$data.selectOptions
    },
    changeLetter() {
      this.getList()
    },
    back() {
      this.$router.back(-1)
    },
    async associated() {
      let events = this.$route.query.event
      let selectList = this.selectList.map(item => item.id)
      // let data1 = { templateId: selectList.join(',') }
      // console.log(data1, '关联参数')
      if (selectList.length === 0) {
        // this.$message.error({
        //   title: 'Associated failed',
        //   content: 'please check the parameter{变量1},{变量2}'
        // })
        await mailEvent.associated(events, selectList)
        this.$router.push('/system/manage-email/actions')
        return
      }
      await mailEvent.associated(events, selectList)
      this.$message.success({
        title: 'Associated Success'
        // content: 'Associated Success'
      })
      await this.getList(this.pagination.current, this.pagination.size)
    }
  }
}
